import DispatchersMixin from '@/mixins/dispatchers';
import commonFunctions from './common-functions';
import Conciliation2Import from './conciliation2-import';

export default {
    name: 'conciliation2',
    mixins: [DispatchersMixin],
    extends: commonFunctions,
    components: {
        Conciliation2Import
    },

    data() {
        return {
            loading: false,
            fields: [
                {
                    key: 'product',
                    label: 'Producto'
                },
                {
                    key: 'currency',
                    label: 'Divisa'
                },
                {
                    key: 'bank_date',
                    label: 'Actualización banco'
                },
                {
                    key: 'bank_start_amount',
                    label: 'Saldo inicial banco'
                },
                {
                    key: 'bank_amount',
                    label: 'Saldo banco'
                },
                {
                    key: 'rd_date',
                    label: 'Actualización RD'
                },
                {
                    key: 'rd_start_amount',
                    label: 'Saldo inicial RD'
                },
                {
                    key: 'rd_amount',
                    label: 'Saldo RD'
                },
                {
                    key: 'diff_amount',
                    label: 'Diferencia'
                },
                {
                    key: 'diff_status',
                    label: 'Estado'
                },
                {
                    key: 'actions',
                    label: '',
                    class: 'actions'
                }
            ],
            items: [
            ],
            showModalUpdateBank: false,
            modalId: 'import_bank',
            columnFilter: {
                product: undefined,
                currency: undefined
            }
        };
    },

    beforeMount() {
        this.loading = true;
        this.fetchData();
    },

    mounted() {
    },

    methods: {
        async fetchData() {
            const res = await this.$paymentsService.getConciliation2Aggregation();
            this.items = res.data.items;
            this.loading = false;
        },
        clickOnRow(row) {
            const tabName = this.constructFullName(row);
            this.$router.push({ name: 'conciliation2-details', query: { name: tabName, id: `detal-${row.product}-${row.currency}`, product: row.product, currency: row.currency } });
        },
        constructFullName(row) {
            // TODO: como vienen las monedas
            return `${this.$t(`operations.products.${row.product}`)} ${{
                'EUR': '€',
                'DOLL': '$'
            }[row.currency]}`;
        },
        updateBankOperations() {
            this.showModalUpdateBank = true;
            this.$bvModal.show(this.modalId);
        },
        hideDetails() {
            this.showModalUpdateBank = false;
            this.$bvModal.hide(this.modalId);
        },
        async updateRDOperations() {
            this.loading = false;
            await this.$paymentsService.conciliation2RDSync();
            await this.fetchData();
            this.loading = true;
        }

    },

    computed: {
        filteredItems() {
            return this.items.filter(item => {
                let keep = true;
                this.fieldKeys.forEach(key => {
                    console.log(key);
                    keep = keep && (this.columnFilter[key] === undefined || item[key] === this.columnFilter[key]);
                });

                return keep;
            });
        },
        fieldKeys() {
            return Object.keys(this.items[0]);
        },
        optionsFilters() {
            const options = {};
            this.fieldKeys.forEach(key => {
                const vals = this.items.map(item => item[key]);
                options[key] = Array.from(new Set(vals));
            });
            return options;
        }

    },
    /**
     * @override
     */
    beforeDestroy() {
    }
};
